

function replaceDegree(content) {
  content = content.replace(
    /\b (\d+(?:\.\d+)?)\s*(?:degree|degrees|deg)\s*(?:celsius|celcius)?\b/gi,
    "$1°C"
  );


  return content;
}

function replaceIE(content) {

  content = content.replace(
    /\bi\.e\.(?!,)/gi,
    "i.e.,"
  );

  return content;
}

function replaceEG(content) {

  content = content.replace(
    /\be\.g\.(?!,)/gi,
    "e.g.,"
  );

  return content;
}

function replaceLTD(content) {

  content = content.replace(
    /\bltd(?!\.)/gi,
    "ltd."
  );

  return content;
}



export function applyReplacements(content) {

  let newContent = content;

  const allReplacements = [
    replaceDegree,
    replaceIE,
    replaceEG,
    replaceLTD
    
  ];

  allReplacements.forEach(fn => {
    newContent = fn(newContent);
  });

  return newContent;

}